import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';


const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Tests. The Service is unavailable. Please try after sometime." };

export default class PriceListStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    priceList = [];
    priceHistory = [];
    rowCount = 0;
    isDrawerOpened = false;
    referrerId = 0;

    minSelfPrice = 0;
    maxSelfPrice = 0;
    minSelfPrefPrice = 0;
    maxSelfPrefPrice = 0;

    minLabPrice = 0;
    maxLabPrice = 0;
    minLabPrefPrice = 0;
    maxLabPrefPrice = 0;
    priceUpdateFlag = 0;


    constructor(props) {

        this.apiProxy = props.apiProxy;

        this.kind = props.kind;
        this.productId = props.productId;
        this.departmentId = props.departmentId;
        this.role = props.role;
        this.priceUpdateFlag = props.priceUpdateFlag;

        makeObservable(this, {
            state: observable,
            message: observable,
            priceList: observable,
            rowCount: observable,
            isDrawerOpened: observable,
            priceHistory: observable,

            minSelfPrice: observable,
            maxSelfPrice: observable,
            minSelfPrefPrice: observable,
            maxSelfPrefPrice: observable,

            minLabPrice: observable,
            maxLabPrice: observable,
            minLabPrefPrice: observable,
            maxLabPrefPrice: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            canApprove: computed,
            isApproved: computed,

            fetchPriceList: action,
            save: action,
            approve: action,
            closeDrawer: action,
        });
    }

    closeDrawer = () => {
        this.isDrawerOpened = false;
        this.priceHistory = [];
    }

    get canApprove() {
        return this.role === "head" && this.minLabPrefPrice > 0 && this.minSelfPrefPrice > 9;
    }

    get isApproved() {
        return this.priceUpdateFlag === 2;
    }

    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    getFetchPriceListURL = () => {

        if (this.kind === "profile") {
            return `${erpApiurl}api/carbon/GetProfilepriceDetailsByProfileId?ProfileID=${this.productId}`;
        }

        return `${erpApiurl}api/Carbon/GetTestpriceDetailsByTestid?Testid=${this.productId}` ;
    }

    showDrawer() {
        this.isDrawerOpened = true;
    }

    /**
     * Obtain the Price List for the selected test or profile based on 
     * the kind of the selected product
     * 
     */
    fetchPriceList = async () => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = this.getFetchPriceListURL();

        try {
            const response = await this.apiProxy.getAsync(apiEndpoint);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.computePriceRange(data);
            this.priceList = data;
            this.rowCount = data.length;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }


    /**
     * "branchId":1,"BranchCode":"KIL","ReferrerId":518,"ReferrerName":"AG DIAGNOSTIC CENTRE","Amount":"","Id":"","ReferrerTypeId":3
     * "TestId": 278,"Amount": 1100,"ProfileID": 0,"DepartmentId": 5,"ReferrerTypeId": 3,"ReferrerId": 8,"BranchId": 2,"CreatedBy": 1,"id": 3
     * @param {*} request 
     */
    save = async (request) => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = `${erpApiurl}api/Carbon/BulkTestPriceUpdate`;

        try {
            const postables = this.transform(request.labPrice, request.selfPrice);
            await this.apiProxy.asyncPost(apiEndpoint, postables);
            await this.fetchPriceList();
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    approvePostables = () => {
        if (this.kind === "profile") {
            return { profileid: this.productId, Testid: 0 };
        }
        return { profileid: 0, Testid: this.productId };
    }

    approve = async () => {

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = `${erpApiurl}api/Carbon/ApproveMainPrice`;


        try {
            await this.apiProxy.asyncPost(apiEndpoint, this.approvePostables());
            this.priceUpdateFlag = 2;
            await this.fetchPriceList();
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    profileTestIdMap = () => {
        if (this.kind === "profile") {
            return { ProfileID: this.productId, testId: 0 };
        }
        return { ProfileID: 0, testId: this.productId };
    }

    transform = (labPrice, selfPrice) => {

        const idMap=this.profileTestIdMap();
        const postables = [];
        for (let i = 0; i < this.priceList.length; i++) {
            let item = this.priceList[i];
            let preferredPrice = item.ReferrerTypeId === 1 ? selfPrice : labPrice
            let price = this.safeParseInt(item.selective_price);
            let membershipDiscount = this.safeParseInt(item.MemberShipDiscount);
            let senior_citizen_discount=this.safeParseInt(item.senior_citizen_discount);

            if (price > 0) {
                item.Amount = price;
            }
            else {
                if (item.prefered_price > 0) {
                    item.Amount = item.prefered_price;
                }
                else {
                    item.Amount = item.Amount > 0 ? item.Amount : preferredPrice;
                }
            }

            postables.push(this.toPostableItem(item, membershipDiscount,senior_citizen_discount));
        }
        return { "BulkTestpricelist": postables, "labPrice": labPrice, "selfPrice": selfPrice, ...idMap };
    }

    payload = (referrerId) => {
        if (this.kind === "profile") {
            return { profileId: this.productId, TestId: 0, ReferrerId: referrerId };
        }
        return { profileId: 0, TestId: this.productId, ReferrerId: referrerId };
    }

    fetchPriceHistory = async (referrerId) => {

        const apiEndpoint = `${erpApiurl}api/Carbon/PriceHistory`;


        try {
            const response = await this.apiProxy.asyncPost(apiEndpoint, this.payload(referrerId));
            const data = await response.json();

            this.priceHistory = data;
        }
        catch (e) {
            console.log(e);
        }
    }

    toPostableItem = (gridItem, discount,senior_citizen_discount) => {
        const postable = {};
        postable["TestId"] = this.kind === "test" ? this.productId : 0;
        postable["Amount"] = gridItem.Amount;
        postable["MemberShipDiscount"] = discount;
        postable["senior_citizen_discount"] = senior_citizen_discount;
        postable["ProfileID"] = this.kind === "profile" ? this.productId : 0;
        postable["DepartmentId"] = this.kind === "profile" ? 100 : this.departmentId;
        postable["ReferrerTypeId"] = gridItem.ReferrerTypeId;
        postable["ReferrerId"] = gridItem.ReferrerId;
        postable["BranchId"] = gridItem.branchId;
        postable["CreatedBy"] = 1;
        postable["id"] = gridItem.Id;

        return postable;
    }

    computePriceRange = (data) => {
        if (data.length <= 0) {
            return;
        }

        let minSelf = 999999;
        let maxSelf = 0;
        let minLab = 999999;
        let maxLab = 0;

        let minSelfPref = 999999;
        let maxSelfPref = 0;
        let minLabPref = 999999;
        let maxLabPref = 0;


        for (let i = 0; i < data.length; i++) {

            let el = data[i];
            el["selective_price"] = 0;

            let typeId = this.parseNull(el.ReferrerTypeId);
            let price = this.parseNull(el.Amount)
            let prefPrice = this.parseNull(el.prefered_price)

            if (typeId === 1) {
                if (price > maxSelf) {
                    maxSelf = price;
                }
                if (price < minSelf) {
                    minSelf = price;
                }
                if (prefPrice > maxSelfPref) {
                    maxSelfPref = prefPrice;
                }
                if (prefPrice < minSelfPref) {
                    minSelfPref = prefPrice;
                }
            }
            else {
                if (price > maxLab) {
                    maxLab = price;
                }
                if (price < minLab) {
                    minLab = price;
                }
                if (prefPrice > maxLabPref) {
                    maxLabPref = prefPrice;
                }
                if (prefPrice < minLabPref) {
                    minLabPref = prefPrice;
                }
            }

        }

        this.minSelfPrice = minSelf;
        this.maxSelfPrice = maxSelf;
        this.minSelfPrefPrice = minSelfPref;
        this.maxSelfPrefPrice = maxSelfPref;

        this.minLabPrice = minLab;
        this.maxLabPrice = maxLab;
        this.minLabPrefPrice = minLabPref;
        this.maxLabPrefPrice = maxLabPref;

    }

    parseNull = (value) => {
        if (!value) {
            return 0;
        }
        return value;
    }

    safeParseInt = (value) => {
        if (value === undefined) {
            return 0;
        }
        if (value != null) {
            return parseInt(value);
        }
        return 0;
    }
}
